'use strict';

exports.__esModule = true;
exports['default'] = componentWillUpdate;

var _property = require('../others/property');

var _property2 = _interopRequireDefault(_property);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function componentWillUpdate(value) {
  return (0, _property2['default'])('componentWillUpdate', value);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/lifecycle/componentWillUpdate.js
// module id = 583
// module chunks = 1